import http from "../../http";

export default {
  list(params) {
    return http.get("cmsservice/customerWall/page", params);
  },
  add(params) {
    return http.post("cmsservice/customerWall/add", params);
  },
  update(params) {
    return http.post("cmsservice/customerWall/update", params);
  },
  delete(params) {
    return http.post("cmsservice/customerWall/delete", params);
  },
  info(id) {
    return http.get("cmsservice/customerWall/info/" + id, {});
  },
  type: {
    tree(params) {
      return http.get("cmsservice/customerWallSort/tree", params);
    },
    add(params) {
      return http.post("cmsservice/customerWallSort/add", params);
    },
    update(params) {
      return http.put("cmsservice/customerWallSort/update", params);
    },
    delete(id) {
      return http.delete("cmsservice/customerWallSort/del/" + id, {});
    }
  }
};
